import { Component, OnInit, ViewChild,ElementRef } from '@angular/core';
import { UserService } from '../../_service/user.service';
import { SharedService } from '../../_service/shared.service';
import { ActivatedRoute, Router  } from '@angular/router';
import {PageEvent, MatPaginator} from '@angular/material/paginator';
import { LeadsService } from '../../_service/leads.service';
import { FeedbackService } from '../../_service/feedback.service';
import * as XLSX from 'xlsx';
import {ConfirmationModalComponent} from '../../common/confirmation-modal/confirmation-modal.component';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
declare var $: any;
import {formatDate} from '@angular/common';

@Component({
  selector: 'app-feedbackreport',
  templateUrl: './feedbackreport.component.html',
  styleUrls: ['./feedbackreport.component.css']
})
export class FeedbackreportComponent implements OnInit {

  @ViewChild(MatPaginator) paginator: MatPaginator;

  perpage:number=25;feedbackList:any=[];length:number=0;pageEvent: PageEvent;loading:boolean=true;myrole:string;
    pageSizeOptions = [10,25,50,100];pageIndex:number=0;loaded:boolean=false;circles=[];circle='';
    search:string;currentUserId:any;circles_copy=[];status='';feedBackUser=[]; feedBackUser_copy=[];feedBack_User='';
    booleanValue: any = false; PageType=0;start_date:string='';end_date:string='';ipd_start_date:string='';ipd_end_date:string='';
    @ViewChild('dateRangeStart', {static: false}) dateRangeStart: ElementRef;
    @ViewChild('dateRangeEnd', {static: false}) dateRangeEnd: ElementRef;
    @ViewChild('ipdDateRangeStart', {static: false}) ipdDateRangeStart: ElementRef;
    @ViewChild('ipdDateRangeEnd', {static: false}) ipdDateRangeEnd: ElementRef;
    @ViewChild('ipdFeedbackDateRangeStart', {static: false}) ipdFeedbackDateRangeStart: ElementRef;
    @ViewChild('ipdFeedbackDateRangeEnd', {static: false}) ipdFeedbackDateRangeEnd: ElementRef;
    constructor(private userapi:UserService,private sharedapi:SharedService,public leadapi:LeadsService,private dialog: MatDialog,private feedbackapi:FeedbackService,) { }

    ngOnInit(): void 
    {
        this.getcircle();
        this.sharedapi.getRole()
        .subscribe((item:string) => {this.myrole=item;});
        this.myrole = localStorage.getItem('role');
        this.currentUserId = localStorage.getItem('loginuserId');
        this.getFeedBackUser();
    }

    setSearchValue(type){
        if(type=='feedbackUser'){
            $("#feedbackUserSearch").val('');
            $("#feedbackUserSearch").focus();
            this.feedBackUser= this.feedBackUser_copy;
        }
    }
    searchOnSelect(searchtText: string, type){
        if (type == 'feedbackUser') {
            this.feedBackUser = this.sharedapi.searchData(searchtText, this.feedBackUser_copy, "name");
        }
    }

    ngAfterViewInit() {
         this.loadFeedBackList(0,this.perpage,this.PageType);
    }

    tabClick(event){
        if(event.index==0){
            this.PageType=0; 
            this.loadFeedBackList(0,this.perpage,this.PageType);
        }else{
            this.PageType=1;
            this.loadFeedBackList(0,this.perpage,this.PageType);
            
        }
    }

    loadFeedBackList(pageIndex,perpage,type)
    {
        console.log(type);
    	this.feedbackList = [];
        this.paginator.pageIndex = pageIndex; 
    	let qString = 'search='+this.search +'&feedBack_User=' + this.feedBack_User +'&date_range='+this.start_date+'-'+this.end_date+'&ipd_date_range='+this.ipd_start_date+'-'+this.ipd_end_date;
        this.loading = true;this.loaded = false;
        this.feedbackapi.getOpdsIpdsFeedbacks(this.paginator.pageIndex,perpage,qString,type).subscribe((data:any) => {
        	this.length = parseInt(data.totaldata);
            this.loading = false;
            this.loaded = true;
            if(data.status)
            {
                this.feedbackList = data.data;
            }else{
                this.feedbackList = [];
            }
           
        }, error => {
            this.loading = false;
            this.loaded = true;
            this.sharedapi.checkError(error);
        });
    }

    pageChange(event)
    {
        this.pageIndex = event.pageIndex;
        this.loadFeedBackList(event.pageIndex,event.pageSize,this.PageType);
    }

    public getServerData(event:PageEvent):any
    {
        this.perpage = event.pageSize;
        this.pageIndex = event.pageIndex;
        this.loadFeedBackList(event.pageIndex,event.pageSize,this.PageType);
    }

    
    async getcircle()
    {
        await this.leadapi.getcircles().subscribe((data:any) => {
            if(data.status)
            {
                this.circles = data.data;
                this.circles_copy = this.circles;
            }else{
                this.circles = [];
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

    getFeedBackUser(status=1)
    {
        this.leadapi.getFeedbackUsers(status).subscribe((data:any) => {
        if(data.status)
        {
            this.feedBackUser = data.data;
            this.feedBackUser_copy=this.feedBackUser;
        }else{
            this.feedBackUser = [];
        }
          }, error => {
              this.sharedapi.checkError(error);
          });
      }

      resetFiltersOpd() {
        this.clearDate();
        this.search=''; this.feedBack_User = ''; 
        this.loadFeedBackList(0,25,0); 
      }
      resetFiltersipd() {
        this.clearipdDate();
        this.clearipdFeedbackDate();
        this.search=''; this.feedBack_User = ''; 
        this.loadFeedBackList(0,25,1); 
      }
      dateRangeChange(date1,date2)
      {
          if(date2.value)
          {
              this.start_date = date1.value;
              this.end_date = date2.value;
          }
      }

      clearDate()
      {
          this.dateRangeStart.nativeElement.value = "";
          this.dateRangeEnd.nativeElement.value = "";
          this.start_date = '';
          this.end_date = '';
      }

      ipdDateRangeChange(date1,date2)
      {
          if(date2.value)
          {
              this.start_date = date1.value;
              this.end_date = date2.value;
          }
      }
      clearipdDate()
      {
          this.ipdDateRangeStart.nativeElement.value = "";
          this.ipdDateRangeEnd.nativeElement.value = "";
          this.start_date = '';
          this.end_date = '';
      }
    exportList()
    {
        if(this.feedbackList.length>0)
        {
            let data = [];

            let titles = ['Patient Name'];
            data.push(titles);
            for(let key in this.feedbackList)
            {
                let exdata = [               
                    this.feedbackList[key].patient
                ];
                data.push(exdata);
            }
            let ws = XLSX.utils.aoa_to_sheet(data);
            /* generate workbook and add the worksheet */
            const wb: XLSX.WorkBook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
 
            /* save to file */
            let utc = new Date().toJSON().slice(0,10).replace(/-/g,'/');
            XLSX.writeFile(wb, 'feedback_report_'+utc+'.xlsx');
        }else{
            this.sharedapi.presentToast('Something went wrong, Try Again!');
        }
    }

    //------------------Export IpdFeedbackList ---------------------//
exportIpdFeedbackList() {
    if (this.feedbackList.length > 0) {
      let data = [];
      let titles = ['Bd Name','Circle Name','Treatment Id','Treatment Name','Hospital Id','Hospital Name','Doctor Id','Doctor Name','Hospital admission process rating','Hospital cleanliness rating','Hospital service rating','Bd behaviour rating','Doctor treatment rating','Billexplanation rating','DischargeProcess rating','Experience with glamyo rating','Overall rating','Description','Ipd created date','Feedback taken by'];
     
      data.push(titles);
      for (let key in this.feedbackList) {
  
        var ipd_created_date =''; 
        if(this.feedbackList[key].ipd_created_date){
          ipd_created_date = formatDate(this.feedbackList[key].ipd_created_date*1000, 'dd MMM, yyyy', 'en-US');
        }
       
        let extData = [this.feedbackList[key].bd_name,this.feedbackList[key].circle_name,this.feedbackList[key].treatment_id,this.feedbackList[key].treatment_name,this.feedbackList[key].hospital_id,this.feedbackList[key].hospital_name,this.feedbackList[key].doctor_id,this.feedbackList[key].doctor_name,this.feedbackList[key].hospital_admission_process_rating,this.feedbackList[key].hospital_cleanliness_rating,this.feedbackList[key].hospital_service_rating,this.feedbackList[key].bd_behaviour_rating,this.feedbackList[key].doctor_treatment_rating,this.feedbackList[key].billexplanation_rating,this.feedbackList[key].dischargeProcess_rating,this.feedbackList[key].experience_with_glamyo_rating,this.feedbackList[key].overall_rating,this.feedbackList[key].description,ipd_created_date,this.feedbackList[key].ipdfeedback_user];
  
        data.push(extData)
      }
      let ws = XLSX.utils.aoa_to_sheet(data);
      /* generate workbook and add the worksheet */
      const wb: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
  
      /* save to file */
      let utc = new Date().toJSON().slice(0, 10).replace(/-/g, '/');
      XLSX.writeFile(wb, 'ipdFeedbackList_' + utc + '.xlsx');
    } else {
      this.sharedapi.presentToast('No Product Data found!');
    }
  }

  ipdFeedbackDateRangeChange(date1,date2)
  {
      if(date2.value)
      {
          this.ipd_start_date = date1.value;
          this.ipd_end_date = date2.value;
      }
  }
  clearipdFeedbackDate()
  {
      this.ipdFeedbackDateRangeStart.nativeElement.value = "";
      this.ipdFeedbackDateRangeEnd.nativeElement.value = "";
      this.ipd_start_date = '';
      this.ipd_end_date = '';
  }
}
